// num を length の値分だけ 0 埋めする
export function fillZero(num: number, length: number): string {
  const strNum = String(num);
  if (strNum.length > length) return strNum;
  return "0".repeat(length - strNum.length) + strNum;
}
